import { Design } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromApiSigned, fetchFromApiSignedIfAdmin } from './fetchFromApi';
import { setLookupIdAsId } from './setLookupIdAsId';

export const fetchDesign = (designId: string, params?: Record<string, any>, signal?: AbortSignal) =>
  (getParams().useGlobalInventoryData
    ? fetchFromApiSigned<Design>(`designs/${designId}`, params, { signal })
    : fetchFromApiSignedIfAdmin<Design>(
        `${getParams().context}s/${getParams().contextId}/designs/${designId}`,
        params,
        { signal }
      )
  ).then(setLookupIdAsId);
